module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-1"
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("CollectoCat\n          "), _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.user.avatarUrl() ? _vm.user.avatarUrl() : '/avatar-placeholder.png'
    }
  }), _vm._v(" "), _c('small', [_c('span', {
    staticClass: "sign-out"
  }, [_vm._v("("), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.signOut($event)
      }
    }
  }, [_vm._v("Sign Out")]), _vm._v(")")])])]), _vm._v(" "), _c('h2', {
    staticClass: "user-info"
  }, [_c('small', [_vm._v("\n            Start to collect your owls...\n          ")]), _vm._v(" "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("\n            " + _vm._s(_vm.user.username ? _vm.user.username : _vm.user.identityAddress) + "\n          ")])]), _vm._v(" "), _vm._l((_vm.owls), function(owl) {
    return _c('div', {
      domProps: {
        "innerHTML": _vm._s(owl)
      }
    }, [_vm._v("\n          " + _vm._s(owl) + "\n        ")])
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfbe47ce","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 778
// module chunks = 1